import React from 'react';
import { PriceDisplay } from './PriceDisplay';
export function ValueBreakdown() {
  const tomos = [{
    emoji: '📗',
    title: 'TOMO 01 — EL CÓDIGO DEL SILENCIO DIGESTIVO',
    value: 4990,
    bullets: ['Qué es el SIBO y por qué nadie te lo diagnosticó antes', 'Los 12 síntomas que nadie conecta con el intestino', 'El mecanismo exacto de la fermentación bacteriana', 'Tu plan de acción: los primeros 3 días']
  }, {
    emoji: '📗',
    title: 'TOMO 02 — LA ALACENA SANADORA',
    value: 4990,
    bullets: ['El semáforo FODMAP adaptado a la feria argentina', 'Los 20 básicos que forman la base de todo el protocolo', 'Dónde comprar cada cosa y cuánto gastar', 'El truco del aceite infusionado con ajo (sabor sin el FODMAP)']
  }, {
    emoji: '📗',
    title: 'TOMO 03 — COCINA DE RESCATE',
    value: 4990,
    bullets: ['42 recetas completas de los 14 días', 'Desayuno, almuerzo y cena sin ajo ni cebolla', 'El chimichurri anti-SIBO para el asado del domingo', 'Todas con ingredientes que conseguís en cualquier super']
  }, {
    emoji: '📗',
    title: 'TOMO 04 — REPARACIÓN NOCTURNA',
    value: 4990,
    bullets: ['El ritual de 7 minutos antes de dormir', 'Las 3 infusiones que reparan la mucosa mientras dormís', 'Cómo optimizar el barrido intestinal nocturno (MMC)', 'El protocolo de sueño que multiplica los resultados']
  }, {
    emoji: '📗',
    title: 'TOMO 05 — PLAN DE VIDA LIBRE',
    value: 6990,
    bullets: ['La reintroducción gradual de alimentos (sin adivinar)', 'Cómo descubrir tu ventana personal de tolerancia', 'El sistema de mantenimiento para no volver al SIBO', 'Sin este tomo tenés recetas. Con este tomo tenés libertad.']
  }];
  const bonuses = [{
    emoji: '🎁',
    title: 'BONO 01 — KIT SOS PANZA GLOBO 48hs',
    value: 2990,
    bullets: ['Protocolo de emergencia cuando la distensión es severa', '5 infusiones de rescate para las próximas 48 horas', 'Resultados visibles desde la primera noche']
  }, {
    emoji: '🎁',
    title: 'BONO 02 — MAPA DE COMPRAS INTELIGENTE',
    value: 1990,
    bullets: ['Lista semanal lista para llevar al super o la feria', 'Qué pedirle exactamente al carnicero (la frase exacta)', 'Marcas argentinas compatibles con el Protocolo']
  }, {
    emoji: '🎁',
    title: 'BONO 03 — TRACKER 14 DÍAS SIN ADIVINAR',
    value: 1990,
    bullets: ['Planilla de seguimiento día a día', 'Medís tu progreso con datos concretos', 'Sabés exactamente dónde estás en el proceso']
  }, {
    emoji: '🎁',
    title: 'BONO 04 — COMER AFUERA SIN EXPLOTAR',
    value: 1990,
    bullets: ['Estrategias para asados, restaurantes y reuniones', 'Qué pedir en un restaurant sin revelar tu protocolo', 'Cómo manejarte en el asado del domingo sin arruinar la semana']
  }, {
    emoji: '🎁',
    title: 'BONO 05 — RITUAL NOCTURNO 10/10',
    value: 1990,
    bullets: ['El ritual de 7 minutos que transforma el sueño en reparación', 'Las plantas exactas y sus dosis', 'Por qué la noche es cuando más sana el intestino']
  }];
  return <section className="bg-forest-50 py-20 px-4" data-id="element-230">
      <div className="max-w-4xl mx-auto" data-id="element-231">
        <h2 className="text-3xl md:text-4xl font-bold text-forest-900 text-center mb-12" data-id="element-232">
          ¿Qué incluye el Protocolo Rescate SIBO™?
        </h2>

        <div className="space-y-6 mb-16" data-id="element-233">
          {tomos.map((tomo, idx) => <div key={idx} className="bg-white p-6 md:p-8 rounded-2xl shadow-md border-l-4 border-forest-900 flex flex-col md:flex-row gap-6" data-id="element-234">
              <div className="text-4xl flex-shrink-0" data-id="element-235">{tomo.emoji}</div>
              <div className="flex-grow" data-id="element-236">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 gap-2" data-id="element-237">
                  <h3 className="text-xl font-bold text-forest-900" data-id="element-238">
                    {tomo.title}
                  </h3>
                  <span className="text-forest-800/60 font-medium" data-id="element-239">
                    Valor: <PriceDisplay amount={tomo.value} data-id="element-240" />
                  </span>
                </div>
                <ul className="space-y-2" data-id="element-241">
                  {tomo.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start space-x-2 text-forest-800" data-id="element-242">
                      <span className="text-gold-500 mt-1" data-id="element-243">•</span>
                      <span data-id="element-244">{bullet}</span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>

        <div className="text-center mb-10" data-id="element-245">
          <h3 className="text-3xl font-bold text-forest-900" data-id="element-246">
            Y además... los 5 bonos:
          </h3>
        </div>

        <div className="space-y-6" data-id="element-247">
          {bonuses.map((bono, idx) => <div key={idx} className="bg-white p-6 md:p-8 rounded-2xl shadow-lg border border-gold-400 flex flex-col md:flex-row gap-6 relative overflow-hidden" data-id="element-248">
              <div className="absolute top-0 right-0 bg-mint text-white font-bold text-xs px-3 py-1 rounded-bl-lg" data-id="element-249">
                GRATIS HOY
              </div>
              <div className="text-4xl flex-shrink-0" data-id="element-250">{bono.emoji}</div>
              <div className="flex-grow" data-id="element-251">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 gap-2 mt-2 md:mt-0" data-id="element-252">
                  <h3 className="text-xl font-bold text-forest-900" data-id="element-253">
                    {bono.title}
                  </h3>
                  <span className="text-forest-800/60 font-medium line-through" data-id="element-254">
                    Valor: <PriceDisplay amount={bono.value} data-id="element-255" />
                  </span>
                </div>
                <ul className="space-y-2" data-id="element-256">
                  {bono.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start space-x-2 text-forest-800" data-id="element-257">
                      <span className="text-gold-500 mt-1" data-id="element-258">•</span>
                      <span data-id="element-259">{bullet}</span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}